import React,{useState} from 'react'
import "./forus.css"
import {useNavigate} from "react-router-dom"
import ProductInfo from '../ProductInfo/ProductInfo';


function ForUs({darazproduct}) {
    const navigate = useNavigate();
    const [data, setData] = useState(darazproduct);

    const handleClick = (index) => {
        const newData = [...data[index]];
        setData(newData); 
        <ProductInfo item={newData} />
    }

  return (
    <div className='daraz-container'>

        {data.map((item,index) => 
                <div className='daraz-info' key={index} onClick={()=>{navigate('/productinfo'); handleClick(index);}}>
                    <img className= "daraz-image"
                        src={item.imageUrl} alt=" "/>  

                    <div className='daraz-detail'>
                        {item.mall ? <div className='daraz-mall'>
                                        <p>mall</p>
                                    </div>   
                                : <div></div> 
                        } 
                        <div className='daraz-title'>
                            <h3>{item.title}</h3>
                        </div>
                        <p className='daraz-price'>{item.price}</p>
                        <p className='daraz-discount'><s>{item.expectedprice}</s> {item.discount}</p>
                        <p className='daraz-rating'>  

                            {Array(item.rating.star).fill(1,(item.rating.star).length, 5).map((i) =>
                                    <p className='star-image'><img src="https://upload.wikimedia.org/wikipedia/commons/thumb/9/99/Star_icon_stylized.svg/1077px-Star_icon_stylized.svg.png" alt ="" /></p>
                                )
                                }
                            <p className='rating-review'>{`(${item.rating.review})`}</p>
                        </p>
                    </div>      
                </div>
        )}

    </div>
  )
}

export default ForUs

 